module.exports = __webpack_public_path__ + "img/17.a079a587.png";